import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const REINVITE_ACCOUNT_MUTATION = gql`
  mutation reinviteAccount(
    $username: String!
  ) {
    reinviteAccount( username: $username) { status }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ReinviteAccountMutation extends Mutation<RootMutation> {
  document = REINVITE_ACCOUNT_MUTATION;
}
